import { render, staticRenderFns } from "./DesignerMenuEditDialog.vue?vue&type=template&id=cf05d386"
import script from "./DesignerMenuEditDialog.vue?vue&type=script&lang=js"
export * from "./DesignerMenuEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports